import $ from 'jquery';

export default function() {
  // Trigger search overlay
  $('[data-show-search-trigger]').on('click', function() {
    var display_mode = $(this).data('search-style');
    if (display_mode === "overlay") {
      $('[data-overlay-search]').toggleClass('is_active');
      $("[data-popup='search-popup']").addClass('is-hidden');
      $('[data-faq-search]').on('focus');  // Focus on the search input
    }
  });

  // Search button click event
  $('[data-faq-search-btn]').on('click', function() {
    var search_q = $('[data-faq-search]').val().toLowerCase();
    //console.log("Search Query:", search_q); // Debugging line
    filterFAQs(search_q);
  });

  // Search input keypress event (Enter key)
  $('[data-faq-search]').on('keydown', function(evt) {
    if (evt.key === 'Enter') { // Check if the pressed key is Enter
      var search_q = $(this).val().toLowerCase(); // Get the search query
      //console.log("Search Query (Enter):", search_q); // Debugging line
      filterFAQs(search_q); // Call the filter function
    }
  });

  // Function to filter FAQs
  function filterFAQs(search_q) {
    const searchTerms = search_q.trim().split(/\s+/).map(term => term.toLowerCase());
    let firstMatchFound = false; // Track if we found the first match

    $("[data-accordion]").each(function() {
      var $this = $(this);
      var $title = $this.find('h2.faq-item__title span').text().toLowerCase();

      // Check if the entire search query matches the title
      if ($title.includes(search_q)) {
      } else {
        // Hide the main item content if no match found
        $this.find('[data-accordion-content]').hide();
      }

      // Check sub-items
      var hasVisibleSubitems = false; // Track if any subitems should be visible
      $this.find('[data-subaccordion]').each(function() {
        var $subtitle = $(this).find('.faq-item__subtitle span').text().toLowerCase();

        // Check if the subtitle contains all search terms
        const allTermsMatch = searchTerms.every(term => $subtitle.includes(term));
        
        if (allTermsMatch) {
          hasVisibleSubitems = true; // Set flag to true if a match is found
          $(this).removeAttr('data--hidden'); // Show matched subtitles

          // If it's the first match, open the accordion
          if (!firstMatchFound) {
            $this.find('[data-accordion-title]').addClass('is-open');
            $this.find('[data-subaccordion]').show(); // Show the subaccordion
            firstMatchFound = true; // Mark that we've opened the first match
          }
        } else {
          $(this).attr('data--hidden', 'true'); // Hide unmatched subtitles
        }
      });
    });
  }

    // Close search 
    $('.search-close').on('click', function() {
      // Clear the search input
      $('[data-faq-search]').val('').attr('placeholder', 'Search FAQs...'); // Set your desired placeholder text here
      filterFAQs(''); // Call the filter function with an empty query to show all items
      $('[data-accordion]').removeAttr('data--hidden').show();
      $('[data-subaccordion]').hide();
      $('[data-accordion-title]').removeClass('is-open');
      var firstDiv = $('.faq-item.accordion').eq(0);
      firstDiv.removeAttr('data--hidden').show();
      firstDiv.find('[data-accordion-title]').addClass('is-open');
      firstDiv.find('[data-subaccordion]').show();
    });

}
